import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";

const FreeDeliveryTag = () => {
  const [opacity, setOpacity] = useState(1);
  const animationDuration = 800;

  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity((prev) => (prev === 1 ? 0.8 : 1));
    }, animationDuration);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        borderRadius: "6px",
        border: "0.5px solid #FFF",
        backgroundColor: "#FF272F",
        px: 1.5,
        py: 0.5,
        ml: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        sx={{
          color: "#FFF",
          fontSize: "9px",
          fontWeight: "700",
          fontFamily: "'Montserrat', sans-serif",
          opacity,
          transition: `opacity ${animationDuration}ms ease-in-out`,
        }}
      >
        FREE
      </Typography>
    </Box>
  );
};

export default FreeDeliveryTag;
